import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IMAGES } from '@image/images';

type MembersContactsData = {
  id: string;
  userImg: string;
  userName: string;
  userSurName: string;
  userSpecial: string;
  primaryNum: string;
  secondaryNum: string;
  smsOpt: boolean;
  faxNum: string;
  email: string;
  verifyEmail: boolean;
  toggle: boolean;
};

type MembersInfoSliceType = {
  name: string;
  membersContactsData: MembersContactsData[];
};

const initialState: MembersInfoSliceType = {
  name: '',
  membersContactsData: [
    {
      id: '1',
      // userImg: IMAGES.avatar,
      userImg: IMAGES.defaultImage,
      userName: 'Karla',
      userSurName: 'Smith',
      userSpecial: 'Product Manager',
      primaryNum: '(123) 456-7890',
      secondaryNum: '(123) 456-7890',
      smsOpt: false,
      faxNum: '',
      email: 'AvaSav@example.com',
      verifyEmail: true,
      toggle: true,
    },
    {
      id: '2',
      // userImg: IMAGES.avatar,
      userImg: IMAGES.defaultImage,
      userName: 'Karla',
      userSurName: 'Smith',
      userSpecial: 'Product Manager',
      primaryNum: '(123) 456-7890',
      secondaryNum: '(123) 456-7890',
      smsOpt: false,
      faxNum: '',
      email: 'AvaSav@example.com',
      verifyEmail: false,
      toggle: false,
    },
    {
      id: '3',
      // userImg: IMAGES.avatar,
      userImg: IMAGES.defaultImage,
      userName: 'Karla',
      userSurName: 'Smith',
      userSpecial: 'Product Manager',
      primaryNum: '(123) 456-7890',
      secondaryNum: '(123) 456-7890',
      smsOpt: false,
      faxNum: '',
      email: 'AvaSav@example.com',
      verifyEmail: false,
      toggle: false,
    },
  ],
};

export const membersContactsSlice = createSlice({
  name: 'membersContacts',
  initialState,
  reducers: {
    setName(state, action: PayloadAction<string>) {
      state.name = action.payload;
    },
    addNewMembersUser(state) {
      state.membersContactsData.push({
        id: new Date().getTime().toString(),
        // userImg: IMAGES.avatar,
        userImg: IMAGES.defaultImage,
        userName: 'New',
        userSurName: 'User',
        userSpecial: 'Specialist',
        primaryNum: '(000) 000-0000',
        secondaryNum: '(000) 000-0000',
        smsOpt: false,
        faxNum: '',
        email: 'newuser@example.com',
        verifyEmail: false,
        toggle: false,
      });
    },
  },
});

export const selectMembersContacts = (state: {
  membersContacts: MembersInfoSliceType;
}) => state.membersContacts;
export const { setName, addNewMembersUser } = membersContactsSlice.actions;
export const membersContactsReducer = membersContactsSlice.reducer;
